// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TraditionalUPS_TheComp__Mnbp_"};